export default {
  init() {
    // const typeSelect = document.querySelector(".property-type-select");
    // const locationSelect = document.querySelector(".property-location-select");
    // const priceSelect = document.querySelector(".property-price-select");

    // typeSelect.addEventListener("change", () => {});

    // locationSelect.addEventListener("change", () => {});

    // priceSelect.addEventListener("change", () => {});

    for (const select of document.querySelectorAll(".property-form select")) {
      select.addEventListener("change", () => {
        window.location.href =
          select.options[select.selectedIndex].dataset.href;
      });
    }
  },
  finalize() {},
};
